import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

import ProductForm from '../../../components/product/ProductForm.vue'
let service = new services();
let validator = new validation();
export default {
    name: 'SellpointTemplate',
    data () {
        return {
            sellpoint:{}
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-form': ProductForm
     },
    methods: {
    
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/SellpointTemplate/script.js